import styled from "styled-components";
import { theme } from "uikit";

const Title = styled.div`
	font-family: "Lato";
	font-style: normal;
	font-weight: 400;
	font-size: 13px;
	line-height: 13px;

	color: ${theme.colors.primary};

	pointer-events: none;
`;

export default Title;
